import { createComponent } from '@mtfe/sweet';
import { common, dom, timeFormat } from '@mtfe/sweet-utils';

import ConvertRedBagModal from '../ConvertRedBagModal/script';
import { hideConvertRedBagModal } from '../ConvertRedBagModal/script';
import NewLoginModal from '../NewLoginModal/script';
import tpl from './dom.html';
import style from './style.less';

const { createUniqueId } = common;
const CASH_BACK_ID = createUniqueId();
const PROCESS_BAR_ID = createUniqueId();

let propsCache = {};

const renderCashBack = async (props = {}, onRenderDone) => {
    propsCache = { ...propsCache, ...props };

    const { http } = propsCache;
    // 1.获取最新数据
    const activityInfo = await http.postActivityInfo();

    // 3.处理业务异常
    if (!activityInfo) {
        return false;
    }
    // eslint-disable-next-line
    const newComp = CashBack({
        activityInfo,
    });
    dom.$id(CASH_BACK_ID).outerHTML = newComp;
    if (onRenderDone instanceof Function) {
        onRenderDone(activityInfo);
    }
};

const calculateArrSum = (array) => {
    if (!Array.isArray(array)) {
        return 0;
    }
    if (array && array.length === 0) {
        return 0;
    }
    return array.reduce((previousValue, currentValue) => {
        const res = previousValue + currentValue;
        return res;
    });
};

/**
 * 返佣活动组件
 * @param {Object} props
 * activityInfo:活动信息
 * loadLogin:美团登录脚本
 * http:http请求
 * loginSuccessCb:登录成功回调
 * oadLx:可选参数，上报统计
 * @returns {String}
 */
const CashBack = async (props = {}) => {
    propsCache = { ...propsCache, ...props };
    const {
        activityInfo,
        loadLogin,
        oadLX,
        http,
        loginSuccessCb,
        isRadius48 = false,
    } = propsCache;

    // 参数检查
    if (!loadLogin) {
        throw new Error('CashBack参数错误:loadLogin');
    }
    if (!(loginSuccessCb instanceof Function)) {
        throw new Error('CashBack参数错误:loginSuccessCb');
    }
    if (!http) {
        throw new Error('CashBack参数错误:loginSuccessCb');
    }
    if (!http.postActivityCoupon) {
        throw new Error('CashBack参数错误:http中缺少兑换优惠券接口');
    }
    if (!http.postActivityInfo) {
        throw new Error('CashBack参数错误:http中缺少获取活动信息接口');
    }

    try {
        if (!activityInfo) {
            throw new Error('参数错误:activityInfo');
        }
        const {
            taskProgress,
            taskTarget,
            awardOnTheWay,
            awardArrivedJustNow,
            taskStatus,
            isActivityOn,
        } = activityInfo.data;

        if (!isActivityOn) {
            return '';
        }
        // 默认值500
        const progressTarget = taskTarget <= 0 ? 500 : taskTarget;

        const canExchange =
            taskProgress > progressTarget
                ? Math.floor(taskProgress / progressTarget)
                : 0;
        const lessThan0 = taskProgress <= 0 || taskStatus === 0;
        const lessThan500 = taskProgress > 0 && taskProgress < progressTarget;
        const sumOfAwardOnTheWay = calculateArrSum(awardOnTheWay);
        const sumOfAwardArrivedJustNow = calculateArrSum(awardArrivedJustNow);
        const showProgress = lessThan0 ? 0 : taskProgress;

        let progressRate = null;
        if (lessThan0) {
            progressRate = 0;
        } else if (lessThan500) {
            progressRate = (taskProgress / progressTarget).toFixed(2);
        } else {
            progressRate = 1;
        }
        const progressPx = `translateX(${progressRate * 67}vw)`;

        const data = {
            progressTarget,
            showProgress,
            canExchange,
            ...activityInfo.data,
            CASH_BACK_ID,
            lessThan0,
            lessThan500,
            sumOfAwardOnTheWay,
            sumOfAwardArrivedJustNow,
            PROCESS_BAR_ID,
            progressPx,
        };

        const events = {
            clickToRulePage: () => {
                // 点击规则
                oadLX && oadLX.mc('b_waimai_ry26dium_mc');
                window.location.href = '#rule';
                return false;
            },
            clickToGetCoupon: async () => {
                // 点击兑换红包
                oadLX && oadLX.mc('b_waimai_8sh1d2qy_mc');
                await renderCashBack({}, async (newActivityData) => {
                    if (
                        newActivityData.data.taskProgress <
                        newActivityData.data.taskTarget
                    ) {
                        return;
                    }
                    try {
                        const couponRes = await http.postActivityCoupon({
                            awardType: 1,
                            value: newActivityData.data.taskTarget,
                            count: 1,
                        });
                        const couponData = couponRes.data[0];
                        ConvertRedBagModal({
                            title: '公众号“美团外卖袋鼠君”,周周领红包',
                            redBagCash: couponData.value / 100,
                            redBagCanUseRule: `满${
                                couponData.couponLimit / 100
                            }元可用`,
                            expirationDate: timeFormat(
                                couponData.expireTime * 1000,
                                'yyyy.MM.dd',
                            ),
                            onUseRedBag: () => {
                                hideConvertRedBagModal();
                            },
                        });
                        await renderCashBack();
                    } catch (error) {
                        console.error('兑换红包出错', error);
                    }
                });
            },
            clickIncentiveActivity: () => {
                if (taskStatus === 0) {
                    NewLoginModal({
                        loadLogin,
                        loginSuccessCb,
                    });
                }
                return false;
            },
        };
        if (isRadius48) {
            style['cash-back-radius'] = style['radiusTop48'];
        } else {
            style['cash-back-radius'] = '';
        }
        const component = createComponent(tpl, { data, style }, events);
        return component;
    } catch (error) {
        console.error('cashback error', error);
        return '';
    }
};

export default CashBack;
export { renderCashBack };
